module.exports = __webpack_public_path__ + "img/light-mud-decal-19.2c7731c1.png";